import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import AdminCompanyEdit from "../components/AdminCompanyEdit";
import {
  fetchIndustries,
  fetchCompanySizes
} from "../../../../actions/dropdowns.actions";
import {
  searchCompanies,
  fetchCompanies,
  createCompany,
  updateCompanyById,
  getAdminCompanyById
} from "../../../../actions/company.actions";
import { searchCitiesAutocomplete } from "../../../../actions/cities.actions";

class AdminCompanyEditContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getAdminCompanyById(this.props.match.params.companyId);
    this.props.fetchIndustries();
    this.props.fetchCompanies();
    this.props.fetchCompanySizes();
  }

  handleSubmit(data) {
    if (data.location && _.isArray(data.location) && data.location.length > 0) {
      data.location = data.location[0].description
        ? data.location[0].description
        : data.location[0];
    }

    const payload = {
      companyId: _.get(this.props.company, "id"),
      name: data.company,
      industry_id: data.industry_id,
      company_size_id: data.company_size_id,
      location: data.location,
      url: data.url,
      summary: data.summary
    };

    this.props.updateCompanyById(payload);
    this.props.history.goBack();
  }

  render() {
    return (
      <AdminCompanyEdit
        onSubmit={this.handleSubmit}
        industries={this.props.industries}
        companies={this.props.companies}
        companySizes={this.props.companySizes}
        companyName={this.props.match.params.companyName}
        cities={this.props.cities}
        onSearchCities={this.props.searchCitiesAutocomplete}
        onSearchCompanies={this.props.searchCompanies}
        createCompany={this.props.createCompany}
        isLoadingCompany={this.props.isLoadingCompany}
        companyId={this.props.match.params.companyId}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    industries: state.dropdowns.industries.data,
    companySizes: state.dropdowns.companySizes.data,
    cities: state.cities.cities.predictions,
    isLoading: state.cities.cities.isLoading,
    companies: state.company.companies.data,
    isLoadingCompany: state.company.isLoading,
    company: state.company.adminCompany
  };
};

const mapDispatchToProps = dispatch => ({
  updateCompanyById: company => dispatch(updateCompanyById(company)),
  getAdminCompanyById: id => dispatch(getAdminCompanyById(id)),
  fetchIndustries: () => dispatch(fetchIndustries()),
  fetchCompanySizes: () => dispatch(fetchCompanySizes()),
  updateCompanyById: company => dispatch(updateCompanyById(company)),
  searchCitiesAutocomplete: query => dispatch(searchCitiesAutocomplete(query)),
  fetchCompanies: () => dispatch(fetchCompanies()),
  createCompany: company => dispatch(createCompany(company)),
  searchCompanies: query => dispatch(searchCompanies(query))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminCompanyEditContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/company/containers/AdminCompanyEditContainer.js